module.exports = __webpack_public_path__ + "static/img/hyperlead-logo.2ddc44a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/hyperlead-logo.png
// module id = UWvo
// module chunks = 45